import axios from 'axios'
import i18n from '@/plugins/i18n'

// Модель для работы с отправкой сообщения
export default {
  // Получение данных для формы
  getFormData (id) {
    return axios.get(`${i18n.locale}/api/notification/getOoptEmailFormData`)
  },
  // Отправка
  sendNotification (data) {
    return axios.post(`${i18n.locale}/api/notification/handleOoptEmailForm`, data)
  }
}
